var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.693,
    height: 21.693,
    viewBox: "0 0 21.693 21.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5736",
    "data-name": "Group 5736",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M14.634,20.693H6.061L0,14.631V6.06L6.061,0h8.572l6.06,6.06v8.571l-6.058,6.062ZM6.461.967h0L.967,6.462V14.23l5.494,5.494h7.77l5.494-5.494V6.462L14.231.967Zm7.555,18.239H6.677l-5.191-5.19V6.675l5.191-5.19h7.339l5.189,5.19v7.341l-5.189,5.19ZM5.7,9.307a.6.6,0,0,0-.341.1.625.625,0,0,0-.211.793l2.486,4.6,0,0a2.482,2.482,0,0,0,2.221,1.36h1.88a2.5,2.5,0,0,0,2.5-2.495V7.436a.631.631,0,0,0-.184-.443.625.625,0,0,0-1.065.443v3.327a.208.208,0,0,1-.415,0V6.188a.624.624,0,0,0-1.248,0v4.575a.208.208,0,0,1-.415,0V5.149a.622.622,0,0,0-.624-.625.625.625,0,0,0-.623.625v5.613a.208.208,0,0,1-.416,0V6.188a.624.624,0,0,0-1.248,0V11.65a.211.211,0,0,1-.148.2.207.207,0,0,1-.058.008.211.211,0,0,1-.176-.1L6.243,9.623s0,0,0,0A.618.618,0,0,0,5.7,9.307Z",
    fill: "#505050",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.2ba35c046d3f2e5abd1c2095c1a15496.svg";
export { ForwardRef as ReactComponent };